import Personalisation from './coredna-personalisation';

// Expose Personalisation globally
window.Coredna = window.Coredna || {};
window.Coredna.Personalisation = Personalisation;

// Initialize when DOM is ready
document.addEventListener('DOMContentLoaded', () => {
	Personalisation.initialize();
});